module.exports = __webpack_public_path__ + "static/media/Figure9.d51ea245.jpg";